import React from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import OnTraccrButton from '../../../../../common/buttons/OnTraccrButton';


export default function TimeTrackingGridWizardDateStep({
  selectedDate,
  setSelectedDate,
  goToNextStep,
}) {
  return (
    <div className="time-tracking-grid-wizard-date-step-container">
      <div className="time-tracking-grid-content-title">Step 1: Select Date</div>
      <div className="time-tracking-grid-content-description">Choose the date for this time tracking grid</div>
      <div className="time-tracking-grid-sub-content">
        <DatePicker
          value={selectedDate ? moment(selectedDate) : null}
          onChange={setSelectedDate}
          format="dddd, MMMM D, YYYY"
          placeholder="Select date"
          className="time-tracking-grid-wizard-date-picker"
          allowClear={false}
        />
        <OnTraccrButton
          title="Continue to Cost Codes"
          onClick={goToNextStep}
          icon={<RightOutlined />}
          className="time-tracking-grid-wizard-content-button"
        />
      </div>
    </div>
  );
}

TimeTrackingGridWizardDateStep.propTypes = {
  selectedDate: PropTypes.string.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  goToNextStep: PropTypes.func.isRequired,
};
